import { Box, styled } from '@mui/material';

export const ButtonsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'oneBtnOnly',
})<{ oneBtnOnly: boolean }>(({ oneBtnOnly }) => ({
  display: 'flex',
  justifyContent: oneBtnOnly ? 'center' : 'space-evenly',
}));
